import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';




const FieldTripClass62026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/5.webp`;
const p6 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/6.webp`;
const p7 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/7.webp`;
const p8 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/8.webp`;
const p9 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/9.webp`;
const p10 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/10.webp`;
const p11 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/11.webp`;
const p12 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/12.webp`;
const p13 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip6/13.webp`;

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}
,
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
}
,
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
}
,
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
}
,
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
}
,
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
}
,
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
}
,
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
}




  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FIELD TRIP CLASS 6
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 6	 DATE OF VISIT: 11 September 2026  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
PLACES OF VISIT: Janapadha Loka & Toy Factory
<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
The students and teachers of Class 6 visited Janapada Loka and a Toy Factory in Channapatna as part of their educational field trip. At Janapada Loka, they explored the rich folk traditions, art, crafts and cultural heritage of Karnataka. They observed traditional artefacts, folk instruments, handicrafts and various displays that provided them with an insight into the customs and lifestyle of rural Karnataka. At the Toy Factory, renowned for its traditional wooden toys, the students observed how toys are designed and made. They learned about the different stages involved in toy-making and gained an understanding of the creativity, skill and effort involved in transforming raw materials into colourful and attractive toys. As a memorable takeaway from the visit, each student 
received a traditional spinning top, which added to the excitement of the experience.<br></br>
The students of Class 7 embarked on an enriching field trip that took students beyond the classroom to explore history, heritage, architecture and nature firsthand, 
connecting textbook learning with real experiences.  
     <br></br>
The students thoroughly enjoyed the trip as it provided them with an opportunity to learn beyond the classroom. They particularly enjoyed exploring the traditional artefacts at Janapada Loka and witnessing the fascinating process of toy-making in the Toy Factory. The field trip helped the students connect classroom learning with real-life experiences. It also encouraged curiosity, observation, teamwork and respect for traditional skills and local artisans. Overall, the visit to Janapada Loka and the Toy Factory was an enriching, 
engaging and memorable learning experience for the students.       
  <br></br>

        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
“A journey beyond the classroom, where culture, creativity and curiosity came alive.”
<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTripClass62026;